import { PageNotFoundComponent } from './page-not-found.component';

export const components: any[] = [PageNotFoundComponent];

export * from './page-not-found.component';
